'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import { cn } from 'cn';
type PopoverProps = PopoverPrimitive.Root.Props;
export function Popover(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <PopoverPrimitive.Root data-slot="popover" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type PopoverTriggerProps = PopoverPrimitive.Trigger.Props;
export function PopoverTrigger(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type PopoverContentProps = PopoverPrimitive.Popup.Props & Pick<PopoverPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>;
export function PopoverContent(props) {
  const $ = _c(18);
  let className;
  let rest;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== props) {
    ({
      className,
      align: t0,
      alignOffset: t1,
      side: t2,
      sideOffset: t3,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const align = t0 === undefined ? "center" : t0;
  const alignOffset = t1 === undefined ? 0 : t1;
  const side = t2 === undefined ? "bottom" : t2;
  const sideOffset = t3 === undefined ? 4 : t3;
  let t4;
  if ($[7] !== className) {
    t4 = cn("z-50 flex w-72 origin-(--transform-origin) flex-col gap-4 rounded-2xl bg-popover p-4 text-sm text-popover-foreground shadow-2xl ring-1 ring-foreground/5 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rest || $[10] !== t4) {
    t5 = <PopoverPrimitive.Popup data-slot="popover-content" className={t4} {...rest} />;
    $[9] = rest;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== align || $[13] !== alignOffset || $[14] !== side || $[15] !== sideOffset || $[16] !== t5) {
    t6 = <PopoverPrimitive.Portal><PopoverPrimitive.Positioner align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset} className="isolate z-50">{t5}</PopoverPrimitive.Positioner></PopoverPrimitive.Portal>;
    $[12] = align;
    $[13] = alignOffset;
    $[14] = side;
    $[15] = sideOffset;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
type PopoverHeaderProps = React.ComponentProps<'div'>;
export function PopoverHeader(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("flex flex-col gap-1 text-sm", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <div data-slot="popover-header" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type PopoverTitleProps = PopoverPrimitive.Title.Props;
export function PopoverTitle(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("text-base font-medium", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <PopoverPrimitive.Title data-slot="popover-title" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type PopoverDescriptionProps = PopoverPrimitive.Description.Props;
export function PopoverDescription(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("text-muted-foreground", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <PopoverPrimitive.Description data-slot="popover-description" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}